/**
 * Rumbo: la última respuesta de `enablebanking-status`, para que cada
 * pantalla nueva no empiece en «sin banca» (el admin veía un momento
 * «Próximamente» antes de su banco). Fuera del hook para poder olvidarla al
 * cerrar sesión sin cargar React.
 */
export type EstadoBanca = { configured: boolean; permitida: boolean };

let ultimaRespuesta: EstadoBanca | null = null;

export function leerEstadoBanca(): EstadoBanca | null {
  return ultimaRespuesta;
}

export function guardarEstadoBanca(estado: EstadoBanca | null) {
  ultimaRespuesta = estado;
}

/**
 * Olvida la respuesta guardada: al cerrar sesión, para que quien entre
 * después en el mismo navegador no herede la banca de quien salió.
 */
export function olvidarEstadoBanca() {
  ultimaRespuesta = null;
}
